import { render } from "./WatchAction.vue?vue&type=template&id=388e523c&lang=pug"
import script from "./WatchAction.vue?vue&type=script&lang=js"
export * from "./WatchAction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__